import { FC, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Box, Container, Typography } from '@mui/material';

import AppStore from '../../assets/images/appstore.png';
import GooglePlay from '../../assets/images/googleplay.png';
import LogoIcon from '../../assets/images/Logo.png';
import MobileDemo from '../../assets/images/Frame 1597880777.png';
import CloudBg from '../../assets/images/Image.png';
import DownloadIcon from '../../assets/icons/Download, Save, Upload.png';

import CustomButton from '../CustomButton';
import { useAppSelector } from '../../hooks/redux';

import styles from './AuthWrapper.module.scss';

type AuthWrapperProps = {
  btnName: 'Sign Up' | 'Sign In';
  children: React.ReactNode;
}

const AuthWrapper: FC<AuthWrapperProps> = ({ children, btnName }) => {
  const navigate = useNavigate();
  const { userInfo } = useAppSelector(state => state.auth);
  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const redirect = sp.get('redirect') || '/profile';

  useEffect(() => {
    if (userInfo) {
      navigate(redirect);
    }
  }, [userInfo, redirect, navigate]);

  return (
    <Box className={styles.authContainerWrapper}>
      <img src={CloudBg} className={styles.imageBg} alt='cloud-bg' />
      <Box className={styles.authHeader}>
        <Box className={styles.logoContainer} onClick={() => navigate('/')}>
          <img className={styles.logoImg} src={LogoIcon} alt="logo" />
          <Typography variant='h8Bold'>TravGenius</Typography>
        </Box>
        <CustomButton
          variant='contained'
          onClick={() => navigate(btnName === 'Sign Up' ? '/sign-up' : '/')}
          customClass={styles.toggledBtn}
        >
          {btnName}
        </CustomButton>
        <CustomButton
          variant='outlined'
          onClick={() => navigate('/sign-in')}
          customClass={styles.downloadContainer}
        >
          <Box className={styles.downloadContentWrapper}>
            <Typography variant='h10Bold'>App</Typography>
            <img className={styles.downloadIcon} src={DownloadIcon} alt="logo" />
          </Box>
        </CustomButton>
      </Box>

      <Container maxWidth="lg" sx={{ padding: '0 !important' }}>
        <Box className={styles.authContent}>
          <Box className={styles.authContentLeft}>
            <Box className={styles.authContentLeftText}>
              <Box>
                <Typography variant='h1Bold'>Your </Typography>
                <Typography variant='h1Bold' className={styles.gradientText}>AI-powered</Typography>
              </Box>
              <Typography variant='h1Bold' sx={{textAlign: 'center'}}>travel planner in one app</Typography>
            </Box>
            <Box className={styles.downloadBtns}>
              <Link to='https://www.apple.com/app-store/'>
                <img
                  src={AppStore}
                  alt="Download on the App Store"
                  style={{ width: '150px' }}
                />
              </Link>
              <Link to='https://play.google.com/store'>
                <img
                  src={GooglePlay}
                  alt="Download on the App Store"
                  style={{ width: '150px' }}
                />
              </Link>
            </Box>
            <img className={styles.mobileDemoImg} src={MobileDemo} alt="mobile demo" />
          </Box>
          <Box className={styles.authContentRight}>
            {children}
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default AuthWrapper;
